import { TableCell } from "@mui/material";

const StatusCell = ({ update }) => (
  <TableCell align="center">
    <div className="flex flex-col items-center">
      <span
        className={`badge ${
          update.status === "pending"
            ? "bg-yellow-500"
            : update.status === "approved"
            ? "bg-green-500"
            : "bg-red-500"
        } text-white p-1 rounded`}
      >
        {update.status}
      </span>
      {update.status === "rejected" && update.rejection_reason && (
        <div className="mt-1 text-xs text-gray-600 max-w-[200px] break-words">
          Reason: {update.rejection_reason}
        </div>
      )}
    </div>
  </TableCell>
);
export default StatusCell;
